import Request from '../Request';
import {setOptions as UtilSetOptions} from 'leaflet/src/core/Util';

export default class SearchDialog {
	constructor(id, resultsId, options) {
		this.options = {
			resultLimit: 10,
			minInputLength: 2
		};

		this.el = id;
		this.elResults = resultsId;
		UtilSetOptions(this, options); // merge constructor options with this.options (defaults)

		this.request = new Request({
			url: 'https://api.weatherusa.net/v1/feed/place',
			link: 'cancel',
			timeout: 15000,
			onSuccess: this.handleResponse.bind(this)
		});
	}

	attachSearchFormListeners() {
		var handler = this;
		$(this.el).on('focus', function() {
			$(this.el).trigger('click');
		});
		$(this.el).on('input', function() {
			if(this.value.length >= handler.options.minInputLength) {
				handler.handleInput(this);
			} else {
				$(handler.elResults).empty().append('<a class="dropdown-item" href="#"><em>Enter more characters</em></a>');
			}
		});
	}

	handleInput(el) {
		// FIXME handleInput should be debounced...
		let $e = $(el);
		this.request.get({
			'q': $e.val(),
			'callbackEl': $e.attr('id')
		});
	}

	handleResponse(obj) {
		let resp = obj.body;

		if( ! resp.callbackEl) return false;
		var fieldId = '#' + resp.callbackEl;
		if($(fieldId).length === 0) return false;
		$(fieldId + '_dropdown').empty();
		if(resp.place == false) {
			$(fieldId).empty().append('<a class="dropdown-item" href="#"><em>No matches</em></a>');
			return false;
		}
		
		// FIXME this part could go into a callback anonymous function to abstract the class

		for(let row of resp.place) {
			var placeNameFull = row.name + ", " + row.state;
			if(row.zip) placeNameFull = placeNameFull + " (" + row.zip + ")";
			$(fieldId + '_dropdown').append($('<a class="dropdown-item" href="#"></a>')
			.attr('data-placeid', row.id)
			.attr('data-placename', placeNameFull)
			.attr('data-lat', row.lat)
			.attr('data-lon', row.lon)
			.prop('draggable', false)
			.html(placeNameFull)
			);
		}
		$(fieldId + '_dropdown > a').on('click', function(e) {
			e.preventDefault();
			window.liveMap.updateLocation(this.dataset.lat, this.dataset.lon, 12);
			$('#fullscreen_search').removeClass('search-mobile');
		});
	}
}
